function checkOverflow (el) {
    var curOverflow = el.style.overflow;

    if (!curOverflow || curOverflow === 'visible') {
        el.style.overflow = 'hidden';
    }

    var isOverflowing = el.clientHeight < el.scrollHeight;
    el.style.overflow = curOverflow;

    return isOverflowing;
};

function hideElement (el) {
    const display = el.style.display;
    el.style.display = 'none';
    return () => {
        el.style.display = display;
    };
}

const textUtils = {
    hasContent: text =>
        $(text).text().replace(/\s\s+/g, '').replace(/\r?\n|\r/, '').length,
    clearUnnecessaryCharacters: text =>
        text.replace(/&nbsp;/gi, '')
};

const unique = array => Array.from(new Set(array));
const extractBoxFonts = fontFamilies =>
    unique(Array.from(new Set(Object.values(fontFamilies))));

export {
    checkOverflow,
    hideElement,
    textUtils,
    unique,
    extractBoxFonts
};
